import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Button, Card } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import {
    BlogTitleBox,
    BlogTitleText,
    BlogTitleButton,
    BlogCardCamp,
    CardImageBody,
    CardTextBody,
    CardDate,
    CardButton,
} from "./blogCardStyle";
import noImage from "../../../assests/images/gnp_noimg.png"
import HtmlContent from "../readMoreLess/htmlContent";
import { BlogCardProps } from "../../../utils/types";

const BlogCard = ({ blogData }: BlogCardProps) => {

    const location = useLocation();
    const navigate = useNavigate();
    let classNameBlogCardText: any = '';

    if (location.pathname === "/") {
        classNameBlogCardText = 'blog-sec-pre';
    } else if (location.pathname === "/about/giving-guides") {
        classNameBlogCardText = 'giving-guides-blog-pre';
    } else {
        classNameBlogCardText = '';
    }

    return (
        <>
            <BlogTitleBox as={Col} sm="12" className="blog_title">
                <BlogTitleText >{MESSAGE.homeBlogTitle}</BlogTitleText>
                <BlogTitleButton>
                    <Button className="btn-outline-success-blue" href="http://203.109.113.155/GNPBlogs/" target="_blank">{MESSAGE.visitBlog}</Button>
                </BlogTitleButton>
            </BlogTitleBox>
            {blogData?.map((blogs: any, index: number) => (
                <BlogCardCamp key={index + 1} as={Col} sm="6" md="6" lg="4">
                    <Card>
                        <CardImageBody>

                            {/* <Card.Img src={blogs?.large_image
                                ? blogs.large_image
                                : noImage} alt={blogs?.blogImg} /> */}
                            <Card.Img src={noImage} alt={blogs?.blogImg} />
                        </CardImageBody>
                        <CardTextBody>
                            <Card.Body>

                                <CardDate>{blogs?.published_date
                                    ? moment(blogs?.published_date).format("MMM D, YYYY")
                                    : "-"}</CardDate>
                                <Card.Title onClick={() => window.location.href = blogs?.link}>{blogs?.title}</Card.Title>
                                <Card.Text className={classNameBlogCardText}>
                                    <HtmlContent
                                        html={blogs?.description}
                                        maxLength={30}
                                        readMore={() => window.location.href = blogs?.link}
                                    />            </Card.Text>

                                <CardButton className={`${location.pathname === "/giving-guides" ? 'giving-guides-blog-btn' : ''}`}>
                                    <Button type="button" className="btn-outline-success-blue" onClick={() => navigate('/toprated')}>{MESSAGE.topFoodNonprofitsBtn}</Button>
                                </CardButton>

                            </Card.Body>

                        </CardTextBody>
                    </Card>
                </BlogCardCamp>
            ))}
        </>
    )
};
export default BlogCard;